export const faqs = [
  {
    question: '男子汉宝藏是什么？',
    answer: '男子汉宝藏是一个专注男性精品好物推荐的华语内容平台。我们从硬核装备、型男穿搭、数码极客、户外探险、品质生活、腕表鉴赏六大维度，为追求品质生活的真男人筛选真正值得拥有的宝藏级单品与生活方式指南。',
  },
  {
    question: '你们的推荐是如何筛选的？',
    answer: '每一件推荐的单品都经过团队成员的长期实测或深度调研。我们不接受品牌付费推广，所有推荐基于真实使用体验。我们的原则是：自己不愿意用的东西，绝不推荐给读者。',
  },
  {
    question: '如何订阅你们的内容？',
    answer: '你可以在首页底部输入邮箱订阅我们的每周精选内容。我们会定期推送最新评测、好物推荐和生活方式内容到你的邮箱，绝不发送垃圾邮件。',
  },
  {
    question: '可以投稿或合作吗？',
    answer: '当然可以！如果你有好的内容想要分享，或者希望与我们进行商业合作，欢迎通过关于我们页面的联系表单与我们取得联系。我们期待与志同道合的朋友交流。',
  },
  {
    question: '网站上的商品在哪里购买？',
    answer: '我们是一个内容推荐平台，不直接销售商品。每篇文章中会注明推荐商品的品牌和型号，你可以在各大电商平台或品牌官网搜索购买。部分文章会附上购买渠道建议。',
  },
];